import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.requesting)?_c(VProgressCircular,{attrs:{"indeterminate":"","color":"primary","size":"18","width":"2"}}):_c('DeliveryStatus',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }